/** A filament or channel color dot; a neutral dot when there is no color. */
export function Swatch({ hex, size = 14 }: { hex: string | null | undefined; size?: number }) {
  return (
    <span
      aria-hidden="true"
      className="dot"
      style={{
        background: hex ?? 'var(--sunk)',
        width: size,
        height: size,
        flex: `0 0 ${size}px`,
        border: '1px solid rgba(0,0,0,.15)',
      }}
    />
  );
}
